import { render, staticRenderFns } from "./TableDdl.vue?vue&type=template&id=315f1952&scoped=true&"
import script from "./TableDdl.vue?vue&type=script&lang=js&"
export * from "./TableDdl.vue?vue&type=script&lang=js&"
import style0 from "./TableDdl.vue?vue&type=style&index=0&id=315f1952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f1952",
  null
  
)

component.options.__file = "TableDdl.vue"
export default component.exports